import React from 'react'
import { string } from 'prop-types'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import GenericDropdown from '../../generic-dropdown.jsx'
import { FormattedMessage } from 'react-intl'

const CapDatatypeFieldSelect = props => {
  const variables = {}
  const qlq = gql`
    {
      cap_datatype_fields {
        datatype_field_uid
        datatype_uid
        name
        description
        code
        field_datatype_uid
        is_required
      }
    }
  `
  return (
    <Query query={qlq} variables={variables}>
      {({ loading, error, data, refetch }) => {
        const options =
          data && data.cap_datatype_fields
            ? data.cap_datatype_fields.map(v => ({
                ...v,
                value: v.datatype_field_uid
              }))
            : []
        return (
          <GenericDropdown
            {...props}
            options={options}
            placeholder={
              props.placeholder ? (
                props.placeholder
              ) : (
                <FormattedMessage
                  id="crm.ui.dropdown.select_datatype_field"
                  defaultMessage="Select Datatype Field"
                />
              )
            }
          />
        )
      }}
    </Query>
  )
}

CapDatatypeFieldSelect.propTypes = {
  accountUid: string.isRequired,
  placeholder: string
}

export default CapDatatypeFieldSelect
